import { SeoComponent } from '@model/content';
import { useI18NextContext } from '@components/hooks';
import { Head } from '@components/common';

export const PageSeoContainer = ({ title, description, destination }: SeoComponent) => {
  const t: any = useI18NextContext();

  return (
    <Head
      metaTitle={t(title, { destination: destination?.display || '' })}
      metaDescription={t(description, { destination: destination?.display || '' })}
    />
  );
};
